// import * as mapi from '@tencent/hy-mapi';
console.log('speed -- begin');
const win = require('global/window');
import speedConfig from '../../../config/speed.config.js';
// import merge from 'lodash.merge';
import objectAssign from 'object-assign';


let isFirstScreenLoad = true;

function getOpts(pageKey) {
	let opts = speedConfig[pageKey];
	if (!opts || !opts.appid || !opts.flag1 || !opts.flag2 || !opts.flag3) {
		opts = null;
	}

	return opts;
}



/**
 * 上报h5的performance测速点
 * @param {String}	pageKey		页面key
 */
export function reportH5Performance(pageKey) {
	let opts = getOpts(pageKey);
	if (opts) {
		if(win) {
			win.onload = () => {
				// 为了防止刚onload拿不到performance点，设置一个定时器
				setTimeout(() => {
					win.AlloyReport && win.AlloyReport.performance && win.AlloyReport.performance(opts);
				}, 100);
			}
		}
		
	}

}


function reportSpeedTime(opts, speedTime) {
	let opts1 = objectAssign({}, opts, {
		speedTime
	})

	win.AlloyReport && win.AlloyReport.huatuo(opts1);
}

function getResourceLoadTime() {
	let jsLoadTime = 0,
		cssLoadTime = 0;
		
	
	let entries = (window.performance && window.performance.getEntries && window.performance.getEntries()) || [];

	entries.forEach((item = {}) => {
		let initiatorType = item.initiatorType;
		
		if(initiatorType) {
			let duration = item.duration;
			if(initiatorType === 'script') {
				
				jsLoadTime += duration;
			} 
			else if(initiatorType === 'link') {
				cssLoadTime += duration;
			}
		}
	});

	return {
		cssLoadTime,
		jsLoadTime
	}
}

/**
 * 上报
 * @param {*} pageKey 
 * @param {*} speedTime 
 */
export function reportCustomSpeed(pageKey, speedTime) {
	let opts = getOpts(pageKey);
	reportSpeedTime(opts, speedTime);

}

/**
 * 上报关键测速点，应该在首屏cgi响应后调用这个函数
 * @param {String} pageKey 		页面key
 */
export function reportFirstScreen(pageKey) {
	let opts = getOpts(pageKey);
	if (!opts || !isFirstScreenLoad) {
		return;
	}


	isFirstScreenLoad = false;

	win.timingDots = win.timingDots || {};

	// 为了成功获取js加载结束时间戳，加一个setTimeout
	let baseDot = win.timingDots[0],
		firstScreenDot = Date.now(); 	// 首屏时间时间戳

	let firstScreenTime = firstScreenDot - baseDot;		// 纯web首屏内容渲染完成时间

	
	let {
		jsLoadTime,
		cssLoadTime
	} = getResourceLoadTime();


	let speedTime = {
		20: firstScreenTime,	// 首屏时间
		21: cssLoadTime,		// css加载时间
		22: jsLoadTime			// js加载时间	
	}
	reportSpeedTime(opts, speedTime);
	
}

console.log('speed -- finish');